import { render, staticRenderFns } from "./assetstable.vue?vue&type=template&id=52099b4d&scoped=true"
import script from "./assetstable.vue?vue&type=script&lang=js"
export * from "./assetstable.vue?vue&type=script&lang=js"
import style0 from "./assetstable.vue?vue&type=style&index=0&id=52099b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52099b4d",
  null
  
)

export default component.exports